import * as React from 'react'
import { observer } from 'mobx-react'

import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import Button from 'components/Button'

import styles from './OverachieverDialog.sass'
import OpportunitiesViewModel from 'opportunities/OpportunitiesViewModel'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: OpportunitiesViewModel
}

export default observer(function OverachieverDialog({ vm }: Props) {
  return (
    <ModalSheet
      showing={vm.overachieverModalVM.showing}
      onRequestClose={vm.overachieverModalVM.close}
    >
      <ModalSheetHeader withCloseButton></ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_archive.svg')}
            alt="Illustration of a hand putting a book on a shelf"
          />

          <ModalSheetContentTitle>
            <span className={styles.title}>Hello there, overachiever!</span>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            <span className={styles.description}>
              Happy to see you’re so eager for more work. Unfortunately, you
              have reached your limit of{' '}
              <span className={styles.bold}>{vm.globalJobCapacity} jobs</span>.
              To unlock more opportunities, complete some of your open jobs
              first.
            </span>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.overachieverModalVM.close}>
            Close
          </Button>
          <Button
            submit
            type="primary"
            onClick={vm.overachieverModalVM.finishOpenJobs}
          >
            Finish Open Jobs
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
